<template>
  <v-card class="mt-4">
    <div>
      <v-card-title><strong>Meus Dados</strong><br /></v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-progress-linear :active="carregando" class="ma-0" color="cyan accent-3" height="3" indeterminate></v-progress-linear>

        <v-form ref="formUsuario" v-model="usuarioValid" lazy-validation class="mt-4">
          <v-expansion-panels v-model="painel" multiple focusable>
            <v-expansion-panel dark class="elevation-0" :disabled="isUpdating">
              <v-divider></v-divider>
              <v-expansion-panel-header :class="validacao.basicos ? 'red--text' : ''">
                <strong>Dados básicos</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 md4>
                      <v-text-field disabled background-color="white" v-model="usuario.identificacao" label="CPF/CNPJ"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md8>
                      <v-text-field disabled background-color="white" v-model="usuario.email" label="E-mail"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field disabled background-color="white" v-model="usuario.nome" label="Nome"></v-text-field>
                    </v-flex>
                    <v-flex xs6 md2 v-if="usuario.identificacao.length != 14 && !usuario.lgpd">
                      <v-text-field
                        autofocus
                        :disabled="isUpdating"
                        v-model="dtNascimento"
                        label="Data de Nascimento"
                        v-mask="'##/##/####'"
                        :rules="[validacao.dtNascimento == false || validacao.dtNascimento, (value) => valida_data_nasc(value)]"
                        color="blue-grey lighten-2"
                        autocomplete="disabled"
                        :name="Math.random()"
                        @change="validacao.dtNascimento = false"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md4 v-if="usuario.identificacao.length != 14 && !usuario.lgpd">
                      <v-autocomplete
                        :disabled="isUpdating"
                        v-model="usuario.sexo"
                        :items="sexos"
                        :filter="filtrarObjetos"
                        hint="Obrigatório"
                        :rules="[validacao.sexo == false || validacao.sexo, (value) => value != null || 'Obrigatório']"
                        label="Sexo"
                        item-text="nome"
                        item-value="id"
                        autocomplete="disabled"
                        :name="Math.random()"
                        no-data-text
                        @change="validacao.sexo = false"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel dark class="elevation-0" :disabled="isUpdating">
              <v-divider></v-divider>
              <v-expansion-panel-header :class="validacao.enderecos ? 'red--text' : ''">
                <strong>Endereços</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex xs12 md12>
                  <v-card>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>
                      <v-dialog persistent v-model="dialogEndereco" max-width="800px">
                        <template v-slot:activator="{ on }" v-if="!endereco.cep">
                          <v-btn color="success" fab small v-on="on">
                            <v-icon color="white" title="Incluir">add</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <br />
                          <v-card-text>
                            <Endereco ref="endereco" :impresso="impresso" :endereco.sync="endereco" :validacao.sync="validacao" :isUpdating.sync="isUpdating"></Endereco>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" @click="dialogEndereco = false">Retornar</v-btn>
                            <v-btn color="blue darken-1" @click="saveEndereco">Atualizar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>

                    <v-data-table mobile-breakpoint="0" :headers="headerEnderecos" :items="enderecos" no-data-text hide-default-footer :items-per-page="50">
                      <template v-slot:item.logradouro="{ item }">
                        {{ item.tipo + " " + item.logradouro }}
                      </template>
                      <template v-slot:item.id="{ item }">
                        <span style="color: red">{{ item.id ? "" : "não salvo" }}</span>
                      </template>
                    </v-data-table>
                    <v-alert v-if="validacao.enderecos" :value="true" color="error" icon="priority_high" outlined>{{ validacao.enderecos }}</v-alert>
                  </v-card>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel dark class="elevation-0" :disabled="isUpdating">
              <v-divider></v-divider>
              <v-expansion-panel-header :class="validacao.telefones ? 'red--text' : ''">
                <strong>Telefones</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex xs12 md12>
                  <v-card>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>
                      <v-dialog persistent v-model="dialogTelefone" max-width="600px">
                        <template v-slot:activator="{ on }" v-if="!telefone.numero">
                          <v-btn color="success" fab small v-on="on">
                            <v-icon color="white" title="Incluir">add</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <br />
                          <v-card-text>
                            <v-form ref="formTelefone" v-model="telefoneValid" lazy-validation class="mt-4">
                              <v-card class="mt-4">
                                <v-card-title>
                                  <strong>Informe seu telefone</strong>
                                </v-card-title>
                                <v-card-text>
                                  <v-divider></v-divider>
                                  <v-container grid-list-md>
                                    <v-layout wrap>
                                      <v-flex xs12 md6>
                                        <v-autocomplete
                                          autofocus
                                          :disabled="isUpdating"
                                          v-model="telefone.tipo"
                                          :items="tiposFone"
                                          :filter="filtrarObjetos"
                                          hint="Obrigatório"
                                          :rules="[validacao.fone_tipo == false || validacao.fone_tipo, (value) => value != null || 'Obrigatório']"
                                          label="Telefone"
                                          item-text="nome"
                                          item-value="id"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                          no-data-text
                                          @change="validacao.fone_tipo = false"
                                        ></v-autocomplete>
                                      </v-flex>
                                      <v-flex xs4 md2>
                                        <v-text-field
                                          :disabled="isUpdating"
                                          v-model="telefone.ddd"
                                          label="DDD"
                                          v-mask="'##'"
                                          hint="Obrigatório"
                                          :rules="[validacao.fone_ddd == false || validacao.fone_ddd, (value) => !!value || 'Obrigatório.', (value) => valida_ddd(value)]"
                                          color="blue-grey lighten-2"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                          @change="validacao.fone_ddd = false"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs8 md4>
                                        <v-text-field
                                          :disabled="isUpdating"
                                          v-model="telefone.numero"
                                          label="Número"
                                          v-mask="'###########'"
                                          hint="Obrigatório"
                                          :rules="[
                                            validacao.fone_numero == false || validacao.fone_numero,
                                            (value) => !!value || 'Obrigatório.',
                                            (value) => (value != null && value.length > 7) || 'Número inválido'
                                          ]"
                                          color="blue-grey lighten-2"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                          @change="validacao.fone_numero = false"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-form>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" @click="dialogTelefone = false">Retornar</v-btn>
                            <v-btn color="blue darken-1" @click="saveTelefone">Atualizar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-data-table mobile-breakpoint="0" :headers="headerTelefones" :items="telefones" no-data-text hide-default-footer :items-per-page="50">
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          v-if="item.id && ['WHATSAPP', 'CELULAR'].includes(item.tipo)"
                          :color="item.tipo == 'WHATSAPP' ? 'green' : 'blue-grey lighten-4'"
                          :title="item.tipo == 'WHATSAPP' ? 'Desmarcar WhatsApp' : 'Marcar como WhatsApp'"
                          @click="whatsapp(item)"
                          >mdi-whatsapp</v-icon
                        >
                      </template>
                      <template v-slot:item.id="{ item }">
                        <span style="color: red">{{ item.id ? "" : "não salvo" }}</span>
                      </template>
                    </v-data-table>
                    <v-alert v-if="validacao.telefones" :value="true" color="error" icon="priority_high" outlined>{{ validacao.telefones }}</v-alert>
                  </v-card>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel dark class="elevation-0" :disabled="isUpdating">
              <v-divider></v-divider>
              <v-expansion-panel-header :class="validacao.cartoes ? 'red--text' : ''">
                <strong>Cartões</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex xs12 md12>
                  <v-card>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>
                      <v-dialog persistent v-model="dialogCartao" max-width="800px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="success" fab small v-on="on" :disabled="cartao.numero != null || !parcela">
                            <v-icon color="white" title="Incluir">add</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <br />
                          <v-card-text>
                            <CartaoCredito ref="cartaoCredito" :validacao.sync="validacao" :isUpdating.sync="isUpdating"></CartaoCredito>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" @click="dialogCartao = false">Retornar</v-btn>
                            <v-btn color="blue darken-1" @click="saveCartao">Atualizar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-data-table mobile-breakpoint="0" :headers="headerCartoes" :items="cartoes" no-data-text hide-default-footer :items-per-page="50">
                      <template v-slot:item.id="{ item }">
                        <span style="color: red">{{ item.id ? "" : "não salvo" }}</span>
                      </template>
                    </v-data-table>
                    <v-alert v-if="validacao.cartoes" :value="true" color="error" icon="priority_high" outlined>{{ validacao.cartoes }}</v-alert>
                    <v-alert v-if="!parcela" :value="true" color="blue lighten-2" icon="priority_high" outlined
                      >Inclusão de novo cartão não disponível - entre em contato com o jornal.</v-alert
                    >
                  </v-card>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel dark class="elevation-0" :disabled="isUpdating">
              <v-divider></v-divider>
              <v-expansion-panel-header :class="validacao.contas ? 'red--text' : ''">
                <strong>Contas</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex xs12 md12>
                  <v-card>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>
                      <v-dialog persistent v-model="dialogConta" max-width="800px">
                        <template v-slot:activator="{ on }" v-if="!conta.numero">
                          <v-btn color="success" fab small v-on="on">
                            <v-icon color="white" title="Incluir">add</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <br />
                          <v-card-text>
                            <ContaCorrente ref="contaCorrente" :validacao.sync="validacao" :isUpdating.sync="isUpdating"></ContaCorrente>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" @click="dialogConta = false">Retornar</v-btn>
                            <v-btn color="blue darken-1" @click="saveConta">Atualizar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-data-table mobile-breakpoint="0" :headers="headerContas" :items="contas" no-data-text hide-default-footer :items-per-page="50">
                      <template v-slot:item.banco="{ item }">
                        {{ item.banco + " - " + item.nomeBanco }}
                      </template>
                      <template v-slot:item.id="{ item }">
                        <span style="color: red">{{ item.id ? "" : "não salvo" }}</span>
                      </template>
                    </v-data-table>
                    <v-alert v-if="validacao.contas" :value="true" color="error" icon="priority_high" outlined>{{ validacao.contas }}</v-alert>
                  </v-card>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel dark class="elevation-0" :disabled="isUpdating" v-if="produtosClube.length > 0">
              <v-divider></v-divider>
              <v-expansion-panel-header :class="validacao.dependentes ? 'red--text' : ''">
                <strong>Dependentes/Integrantes</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex xs12 md12>
                  <v-card>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>
                      <v-dialog persistent v-model="dialogDependente" max-width="600px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="success" fab small v-on="on">
                            <v-icon color="white" title="Incluir">add</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <br />
                          <v-card-text>
                            <v-form ref="formDependente" v-model="dependenteValid" lazy-validation class="mt-4">
                              <v-card class="mt-4">
                                <v-card-title>
                                  <strong>Informe os dados do seu dependente</strong>
                                </v-card-title>
                                <v-card-text>
                                  <v-divider></v-divider>
                                  <v-container grid-list-md>
                                    <v-layout wrap>
                                      <v-flex xs12 md12>
                                        <v-text-field
                                          autofocus
                                          v-model="dependente.identificacao"
                                          :label="'Identificação (' + (dependente.identificacao.length == 11 ? 'CPF' : 'CNPJ') + ')'"
                                          v-mask="'##############'"
                                          hint="Obrigatório"
                                          :rules="[(value) => !!value || 'Obrigatório.', (value) => valida_identificacao(value)]"
                                          color="blue-grey lighten-2"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 md12>
                                        <v-text-field
                                          v-model="dependente.nome"
                                          label="Nome"
                                          maxlength="100"
                                          hint="Obrigatório"
                                          :rules="[(value) => !!value || 'Obrigatório.', (value) => value.length > 2 || 'Preencha o nome do dependente/integrante']"
                                          color="blue-grey lighten-2"
                                          @change="dependente.nome = pLetra(dependente.nome)"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 md12>
                                        <v-text-field
                                          v-model="dependente.associacao"
                                          label="Associação"
                                          maxlength="30"
                                          hint="Obrigatório"
                                          :rules="[
                                            (value) => !!value || 'Obrigatório.',
                                            (value) =>
                                              (value != null && value.length > 2) || 'Preencha a associação (parentesco, etc) do dependente/integrante com o cliente titular'
                                          ]"
                                          color="blue-grey lighten-2"
                                          @change="dependente.associacao = pLetra(dependente.associacao)"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 md12>
                                        <v-text-field
                                          v-model="dependente.email"
                                          label="E-mail"
                                          maxlength="100"
                                          :rules="[(value) => valida_email_identificacao(value)]"
                                          color="blue-grey lighten-2"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                          @change="dependente.email = dependente.email.toLowerCase()"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs3>
                                        <v-text-field
                                          v-model="dependente.foneDDD"
                                          label="DDD"
                                          v-mask="'##'"
                                          :rules="[(value) => value == '' || valida_ddd(value) || 'DDD inválido']"
                                          color="blue-grey lighten-2"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs9>
                                        <v-text-field v-model="dependente.foneNumero" label="Telefone" v-mask="'###########'" color="blue-grey lighten-2"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-text-field
                                          v-model="dependente.dtNasc"
                                          label="Data de Nascimento"
                                          v-mask="'##/##/####'"
                                          :rules="[(value) => valida_data_nasc(value) || 'Data inválida']"
                                          color="blue-grey lighten-2"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs6 md4>
                                        <v-autocomplete
                                          v-model="dependente.sexo"
                                          :items="sexos"
                                          :filter="filtrarObjetos"
                                          hint="Obrigatório"
                                          :rules="[(value) => value != null || 'Obrigatório']"
                                          label="Sexo"
                                          item-text="nome"
                                          item-value="id"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                          no-data-text
                                        ></v-autocomplete>
                                      </v-flex>
                                      <v-flex xs12>
                                        <v-autocomplete
                                          v-if="produtosClube.length > 0"
                                          v-model="dependente.produtosClube"
                                          :items="produtosClube"
                                          :filter="filtrarObjetos"
                                          label="Produtos do Clube"
                                          item-text="nome"
                                          item-value="id"
                                          autocomplete="disabled"
                                          :name="Math.random()"
                                          no-data-text
                                          return-object
                                          multiple
                                        ></v-autocomplete>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-form>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" @click="dialogDependente = false">Retornar</v-btn>
                            <v-btn color="blue darken-1" @click="saveDependente">Atualizar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-data-table mobile-breakpoint="0" :headers="headerDependentes" :items="dependentes" no-data-text hide-default-footer :items-per-page="50">
                      <template v-slot:item.dtNascimento="{ item }">
                        {{ formatDate(item.dtNascimento) }}
                      </template>
                      <template v-slot:item.foneNumero="{ item }">
                        {{ item.foneNumero ? item.foneDDD + " " + item.foneNumero : "" }}
                      </template>
                      <template v-slot:item.id="{ item }">
                        <span style="color: red">{{ item.id ? "" : "não salvo" }}</span>
                      </template>
                    </v-data-table>
                    <v-alert v-if="validacao.dependentes" :value="true" color="error" icon="priority_high" outlined>{{ validacao.dependentes }}</v-alert>
                  </v-card>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
        <v-divider></v-divider>
        <br />
        <v-flex xs12>
          <v-sheet class="ml-1 red--text" :value="true" v-if="validacao.mensagemErro">{{ validacao.mensagemErro }}</v-sheet>
        </v-flex>
        <v-flex xs12 class="text-center">
          <v-btn :disabled="isUpdating" class="primary" large @click="salvar" :loading="isUpdating">Salvar</v-btn>
        </v-flex>
      </v-card-text>
    </div>

    <v-dialog persistent v-model="dialogConfirm" max-width="400">
      <v-card>
        <v-toolbar>
          <span class="headline">Confirmação</span>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs9 class="ml-4 mb-2" style="min-height: 160px">
                <h3 class="mt-2">Assinatura</h3>
                <h2>{{ parcela ? parcela.idAssinatura : "" }}</h2>

                <h3 class="mt-2">Forma Atual</h3>
                <h2>{{ parcela ? parcela.tipo : "" }}</h2>

                <h3 class="mt-2">Vencimento</h3>
                <h2>{{ parcela ? formatDate(parcela.dtVecto) : "" }}</h2>

                <h3 class="mt-2">Valor</h3>
                <h2>{{ parcela ? formatCurrency(parcela.valor) : "" }}</h2>

                <h3 class="mt-2">Parcelamento</h3>
                <h2>{{ parcela ? parcela.nroParcelas + "x" : "" }}</h2>
              </v-flex>
              <v-flex xs12 class="mt-4" style="font-weight: bold; color: blue">
                <span
                  >Para validação, {{ parcela && parcela.nroParcelas > 1 ? "as parcelas acima serão cobradas no seu cartão" : "a parcela acima será cobrada no seu cartão" }}.
                  Confirma?</span
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="confirmar">Sim</v-btn>
          <v-btn color="primary" text @click="dialogConfirm = false">Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackErro" color="error" :timeout="7000" centered>{{ mensagem }}</v-snackbar>
  </v-card>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../util";
import Endereco from "../components/Endereco.vue";
import CartaoCredito from "../components/CartaoCredito.vue";
import ContaCorrente from "../components/ContaCorrente.vue";
export default {
  components: { Endereco, CartaoCredito, ContaCorrente },
  data() {
    return {
      usuario: { identificacao: "" },
      endereco: {},
      telefone: { tipo: "WHATSAPP" },
      conta: {},
      cartao: { numero: null },
      dependente: { identificacao: "", nome: "", email: "", associacao: "", foneDDD: "", foneNumero: "", produtos: "", nomesProdutos: "", produtosClube: [], sexo: null },

      validacao: {
        dtNascimento: false,
        sexo: false,

        fone_tipo: false,
        fone_ddd: false,
        fone_numero: false,

        cep: false,
        idUF: false,
        idMunicipio: false,
        idCEP: false,
        bairro: false,
        idTipo: false,
        logradouro: false,
        numero: false,
        complemento: false,
        idModoEntrega: false,

        cartao_numero: false,
        cartao_nome: false,
        cartao_validade: false,
        cartao_cvv: false,

        conta_idBanco: false,
        conta_agencia: false,
        conta_numero: false,

        dependente_identificacao: false,
        dependente_email: false,
        dependente_sexo: false,

        enderecos: false,
        telefones: false,
        cartoes: false,
        contas: false,
        dependentes: false,

        mensagemErro: false
      },

      dtNascimento: null,
      enderecos: [],
      telefones: [],
      cartoes: [],
      contas: [],
      dependentes: [],

      headerEnderecos: [
        { text: "Logradouro", value: "logradouro" },
        { text: "Número", value: "numero" },
        { text: "Complemento", value: "complemento" },
        { text: "Bairro", value: "bairro" },
        { text: "Município", value: "municipio" },
        { text: "UF", value: "uf" },
        { text: "CEP", value: "cep" },
        { text: "", value: "id" }
      ],
      headerTelefones: [
        { text: "Tipo", value: "tipo" },
        { text: "DDD", value: "ddd" },
        { text: "Número", value: "numero" },
        { text: "Ações", value: "actions" },
        { text: "", value: "id" }
      ],
      headerCartoes: [
        { text: "Nome", value: "nome" },
        { text: "Número", value: "numero" },
        { text: "Validade", value: "validade" },
        { text: "", value: "id" }
      ],
      headerContas: [
        { text: "Banco", value: "banco" },
        { text: "Agência", value: "agencia" },
        { text: "Conta", value: "numero" },
        { text: "", value: "id" }
      ],
      headerDependentes: [
        { text: "Identificação", value: "identificacao" },
        { text: "Nome", value: "nome" },
        { text: "Nascimento", value: "dtNascimento" },
        { text: "Associação", value: "associacao" },
        { text: "E-mail", value: "email" },
        { text: "Telefone", value: "foneNumero" },
        { text: "Produtos", value: "nomesProdutos" },
        { text: "", value: "id" }
      ],

      sexos: [
        { id: "M", nome: "Masculino" },
        { id: "F", nome: "Feminino" },
        { id: "O", nome: "Outros" },
        { id: "N", nome: "Não Informado" }
      ],
      tiposFone: [
        { id: "WHATSAPP", nome: "Whatsapp" },
        { id: "CELULAR", nome: "Celular" },
        { id: "RESIDENCIAL", nome: "Residencial" },
        { id: "COMERCIAL", nome: "Comercial" }
      ],
      produtosClube: [],

      dialogEndereco: false,
      dialogTelefone: false,
      dialogCartao: false,
      dialogConta: false,
      dialogDependente: false,
      dialogConfirm: false,

      impresso: false,
      parcela: null,
      usuarioValid: true,
      telefoneValid: true,
      dependenteValid: true,
      confirmarCartao: false,

      painel: [0],
      snackErro: false,
      mensagem: "",
      isUpdating: false,
      carregando: true
    };
  },
  methods: {
    async salvar() {
      if (this.confirmarCartao) {
        this.dialogConfirm = true;
        return;
      }
      this.dialogConfirm = false;

      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        if (!this.$refs.formUsuario.validate()) {
          this.validacao.mensagemErro = "Verifique os campos indicados em vermelho no formulário";
          return;
        }

        //* Define os dados a serem enviados
        var body = {
          dtNascimento: this.dtNascimento ? util.formatDateUS(this.dtNascimento) : null,
          sexo: this.usuario.sexo ? this.usuario.sexo : "N"
        };

        if (this.endereco.cep) {
          this.endereco.cep = util.somenteNumeros(this.endereco.cep);
          this.endereco.cobranca = 1;
          this.endereco.entrega = this.impresso;
          body.endereco = this.endereco;
        }
        if (this.telefone.numero) {
          body.telefone = this.telefone;
        }
        if (this.cartao.numero) {
          body.cartao = this.cartao;
        }
        if (this.conta.numero) {
          body.conta = this.conta;
        }
        body.dependentes = [];
        this.dependentes.forEach((element) => {
          if (!element.id) {
            var produtosClubeCommit = [];
            element.produtosClube.forEach((produto) => {
              produtosClubeCommit.push({ idDependente: element.id, idProduto: produto.id });
            });
            body.dependentes.push({
              identificacao: element.identificacao,
              nome: element.nome,
              dtNascimento: element.dtNasc == null ? null : util.formatDateUS(element.dtNasc),
              clubeCortesia: 0,
              associacao: element.associacao,
              email: element.email,
              foneDDD: element.foneDDD,
              foneNumero: element.foneNumero,
              produtosClube: produtosClubeCommit,
              sexo: element.sexo,
              situacao: 1
            });
          }
        });

        //* Envia o usuário
        const response = await api.put("/ass/paywall/usuario", body);

        if (response.data.erro) {
          util.validaErros(this.validacao, response.data.erros);

          setTimeout(() => {
            //* Recarrega a tela
            this.$router.push("/meus-dados");
            this.$router.go("/meus-dados");
          }, 3000);
        } else {
          //* Recarrega a tela
          this.$router.push("/meus-dados");
          this.$router.go("/meus-dados");
        }
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
          if (this.validacao.cartoes) {
            setTimeout(() => {
              this.$router.push("/meus-dados");
              this.$router.go("/meus-dados");
            }, 2000);
          }
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
      }
    },

    async carregarUsuario() {
      try {
        const response = await api.get("/ass/paywall/usuario");
        this.usuario = response.data;
        this.dtNascimento = util.formatDate(this.usuario.dtNascimento);
        this.impresso = this.usuario.impresso;
        this.parcela = this.usuario.parcela;

        this.enderecos = this.usuario.enderecos;
        this.telefones = this.usuario.telefones;
        this.cartoes = Object.assign([], this.usuario.cartoes);
        this.contas = this.usuario.contas;
        this.dependentes = this.usuario.dependentes;

        this.dependentes.forEach((element) => {
          element.nomesProdutos = "";
          element.produtosClube = [];

          if (element.produtos && element.produtos.length) {
            var produtos = element.produtos.split(",");
            produtos.forEach((produto) => {
              element.nomesProdutos += (element.nomesProdutos ? "," : "") + produto.split("-")[1];
              element.produtosClube.push({ id: parseInt(produto.split("-")[0]), nome: produto.split("-")[1], tipo: "CLUBE" });
            });
          }
        });
      } catch (e) {
        this.$router.push("/assine");
      }
    },
    async carregarProdutosClube() {
      try {
        if (this.$store.state.site.paywallIncluirDependente) {
          const response = await api.get("/ass/paywall/produtos?tipo=CLUBE");
          this.produtosClube = response.data;
        }
      } catch (e) {
        this.$router.push("/assine");
      }
    },
    async carregarAssinaturas() {
      try {
        const response = await api.get("/ass/paywall/assinaturas");
        const assinaturas = response.data;
        for (let index = 0; index < assinaturas.length; index++) {
          const element = assinaturas[index];
          if (element.status == "PENDENTE") {
            this.mensagem = "Você possui uma assinatura PENDENTE - redirecionando para a tela de ativação...";
            this.snackErro = true;
            setTimeout(() => {
              this.$router.push("/ativar/" + element.id);
            }, 5000);
            break;
          }
        }
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
        this.snackErro = true;
      }
    },

    saveEndereco() {
      var novoEndereco = this.$refs.endereco.retornaEndereco();
      if (!novoEndereco.cep) {
        return;
      }
      this.endereco = novoEndereco;
      this.enderecos.push(this.endereco);
      this.dialogEndereco = false;

      if (this.impresso) {
        this.mensagem =
          "Atenção: ao clicar em Salvar, todas as próximas edições das suas assinaturas serão entregues neste novo endereço" +
          (this.$store.state.site.paywallValidarRota ? "" : " (se houver rota disponível)") +
          ".";
        this.snackErro = true;
      }
    },
    saveTelefone() {
      if (!this.$refs.formTelefone.validate()) {
        return;
      }
      this.telefones.push(this.telefone);
      this.dialogTelefone = false;
    },
    saveCartao() {
      var novoCartao = this.$refs.cartaoCredito.retornaCartao();
      if (!novoCartao.numero) {
        return;
      }
      this.cartao = novoCartao;
      this.cartoes.push(this.cartao);
      this.dialogCartao = false;
      this.confirmarCartao = true;
    },
    saveConta() {
      var novaConta = this.$refs.contaCorrente.retornaConta();
      if (!novaConta.numero) {
        return;
      }
      this.conta = novaConta;
      this.contas.push(this.conta);
      this.dialogConta = false;
    },
    saveDependente() {
      this.validacao.dependentes = false;
      if (!this.$refs.formDependente.validate()) {
        return;
      }
      this.dependente.dtNascimento = util.formatDateUS(this.dependente.dtNasc);
      this.dependente.produtos = "";
      this.dependente.nomesProdutos = "";
      this.dependente.produtosClube.forEach((produto) => {
        this.dependente.produtos += (this.dependente.produtos ? "," : "") + produto.id + "-" + produto.nome;
        this.dependente.nomesProdutos += (this.dependente.nomesProdutos ? "," : "") + produto.nome;
      });

      this.dependentes.push(this.dependente);
      this.dependente = { identificacao: "", nome: "", email: "", associacao: "", produtos: "", nomesProdutos: "", produtosClube: [] };
      this.dialogDependente = false;
    },
    async confirmar() {
      this.confirmarCartao = false;
      await this.salvar();
    },

    async whatsapp(item) {
      this.isUpdating = true;
      try {
        await util.limparObjeto(this.validacao, false);

        //* Define os dados a serem enviados
        var body = {
          whatsapp: item.tipo == "WHATSAPP" ? "CELULAR" : "WHATSAPP"
        };

        //* Envia o telefone
        await api.put("/ass/paywall/whatsapp/" + item.id, body);

        if (item.tipo == "WHATSAPP") {
          item.tipo = "CELULAR";
        } else {
          item.tipo = "WHATSAPP";
        }
      } catch (e) {
        if (e.toString().includes("status code 400")) {
          this.validacao.mensagemErro = "SESSÃO EXPIRADA";
        } else if (e.response && e.response.data) {
          util.validaErros(this.validacao, e.response.data);
        } else {
          this.validacao.mensagemErro = "Ocorreu um erro indeterminado, verifique sua conexão";
        }
      } finally {
        this.isUpdating = false;
      }
    },

    pLetra(text) {
      text = util.removeSomenteEspeciais(text);
      return util.pLetra(text);
    },
    filtrarObjetos(item, queryText, itemText) {
      return util.filtrarObjetos(item, queryText, itemText);
    },
    valida_data_nasc(date) {
      if (!util.valida_data_nasc_BR(date)) {
        return "Data de nascimento inválida";
      }
      return true;
    },
    valida_ddd(ddd) {
      if (ddd && !util.isDDDvalido(ddd)) {
        return "DDD inválido";
      }
      return true;
    },
    valida_identificacao(text) {
      if (text) {
        if (text.length != 11 && text.length != 14) {
          return "Identificação deve ter 11 ou 14 dígitos";
        } else {
          if (text.length == 11) {
            return util.valida_cpf(text) ? true : "CPF inválido";
          } else {
            return util.valida_cnpj(text) ? true : "CNPJ inválido";
          }
        }
      }
      return true;
    },
    valida_email_identificacao(text) {
      if (!util.valida_email(text)) {
        //* Caso o cliente não possua e-mail, permite entrar com a identificação para não quebrar a chave única
        if (text != util.somenteNumeros(text) || (!util.valida_cpf(text) && !util.valida_cnpj(text))) {
          return "E-mail inválido.";
        }
      }
      return true;
    },
    formatCurrency(val) {
      return util.formatCurrency(val);
    },
    formatDate(date) {
      return util.formatDate(date);
    }
  },
  watch: {
    validacao() {}
  },
  async created() {
    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);

    document.title = this.$store.state.site.nome;
    await this.carregarUsuario();
    if (!this.$store.state.login || this.$store.state.usuario.idDependente || !this.$store.state.site.assinante) {
      if (this.$store.state.usuario.idDependente) {
        if (this.$store.state.site.flip) {
          this.$router.push("/newflip");
        } else {
          this.$router.push("/alterar-senha");
        }
      } else {
        this.$router.push("/assine");
      }
    }
    await this.carregarAssinaturas();
    await this.carregarProdutosClube();
    this.carregando = false;
  }
};
</script>
